module.exports = __webpack_public_path__ + "img/slogn_bg.954b93e5.jpg";